import axios from "axios"

const service = axios.create({
  baseURL: "https://apimusic.mrzhj.cn/",
  // baseURL: "http://127.0.0.1:3000/",
  times: 10000
})

axios.defaults.withCredentials = true

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json"
    // config.headers["Access-Control-Allow-Credentials"] = true
    return config
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
service.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    return Promise.reject(error)
  }
)

/* 封装axios */
export const http = (method, url, params, config = {}) => {
  return new Promise((resolve, reject) => {
    service({
      method: method,
      url,
      params,
      ...config
    })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/* 统一封装get请求 */
export const get = (url, params, config = {}) => {
  return new Promise((resolve, reject) => {
    service({
      method: "get",
      url,
      params,
      ...config
    })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/* 统一封装post请求  */
export const post = (url, data, config = {}) => {
  return new Promise((resolve, reject) => {
    service({
      method: "post",
      url,
      data,
      ...config
    })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// return { service, get, post }
